module.exports = __webpack_public_path__ + "img/1 (4).b59dab67.png";